import { render, staticRenderFns } from "./CustChooseDialog.vue?vue&type=template&id=5bcc83a3&scoped=true"
import script from "./CustChooseDialog.vue?vue&type=script&lang=js"
export * from "./CustChooseDialog.vue?vue&type=script&lang=js"
import style0 from "./CustChooseDialog.vue?vue&type=style&index=0&id=5bcc83a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcc83a3",
  null
  
)

export default component.exports